// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3Fdw3","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1B1s4"};